export default __webpack_public_path__ + "static/media/48.1c4594c4.png";